import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useAmountsContext } from '@components/amounts-received/hooks/use-amounts-context/use-amounts-context.hook'
import { Amount, IAmount } from '@components/amounts-received/hooks/use-amounts/use-amounts.hook'
import ValuesControl from '@components/values-control/values-control.component'
import './heading.component.scoped.scss'

interface Props {
  onChange?: (hideValue: boolean) => any
}

const Heading = ({ onChange }: Props) => {
  const { t } = useTranslation('heading')

  const { setState }: IAmount = useAmountsContext()

  const handleChange = useCallback(
    (value: boolean) => {
      setState((prevState: Amount) => ({ ...prevState, hideValue: value }))

      if (onChange && typeof onChange === 'function') {
        onChange(value)
      }
    },
    [onChange, setState]
  )

  return (
    <div className="heading">
      <h3 className="title m-0">{t('title')}</h3>
      <ValuesControl valueChange={(value: boolean) => handleChange(value)} />
    </div>
  )
}

export default Heading
